import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { PopularLabelsMacroRendererProps } from '../src/PopularLabelsMacroRenderer.tsx';

export const PopularLabelsMacroHandler: LoadableType<PopularLabelsMacroRendererProps> =
	LoadablePaint({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-PopularLabelsMacro" */ '../src/PopularLabelsMacroRenderer.tsx'
				)
			).PopularLabelsMacroRenderer,
	});
